import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {    
    ReservationSearchCriteria,
    OfferCreate,
    OfferDetail,
    ReservationList,
    ReservationDetail
} from '../../_models/reservation.model';
import { ApiResponse } from '../../_models/api-response.model';
import { Page } from '../../_models/page.model';

@Injectable({
    providedIn: 'root'
})
export class ReservationAdminService {
    private adminApiUrl = `${environment.apiUrl}/admin/reservations`;

    constructor(private http: HttpClient) { }

    getAllReservations(
        criteria: ReservationSearchCriteria = {},
        page: number = 0,
        size: number = 10,
        sort: string = 'createdAt',
        direction: string = 'DESC'
    ): Observable<ApiResponse<Page<ReservationList>>> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString())
            .set('sort', sort)
            .set('direction', direction);

        if (criteria.search) {
            params = params.set('search', criteria.search);
        }
        if (criteria.clientId) {
            params = params.set('clientId', criteria.clientId.toString());
        }
        if (criteria.startDateFrom) {
            params = params.set('startDateFrom', criteria.startDateFrom);
        }
        if (criteria.startDateTo) {
            params = params.set('startDateTo', criteria.startDateTo);
        }
        if (criteria.clientStatus) {
            params = params.set('clientStatus', criteria.clientStatus);
        }
        if (criteria.adminStatus) {
            params = params.set('adminStatus', criteria.adminStatus);
        }

        return this.http.get<ApiResponse<Page<ReservationList>>>(this.adminApiUrl, { params });
    }

    getReservationDetails(reservationId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.get<ApiResponse<ReservationDetail>>(`${this.adminApiUrl}/${reservationId}`);
    }

    createOffer(reservationId: number, offerCreate: OfferCreate): Observable<ApiResponse<OfferDetail>> {
        return this.http.post<ApiResponse<OfferDetail>>(
            `${this.adminApiUrl}/${reservationId}/offers`,
            offerCreate
        );
    }

    updateOffer(offerId: number, offerCreate: OfferCreate): Observable<ApiResponse<void>> {
        return this.http.put<ApiResponse<void>>(
            `${this.adminApiUrl}/offers/${offerId}`,
            offerCreate
        );
    }

    deleteOffer(offerId: number): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`${this.adminApiUrl}/offers/${offerId}`);
    }

    refuseReservation(reservationId: number): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.adminApiUrl}/${reservationId}/refuse`,
            {}
        );
    }
}